<template>
    <div>
        <c-inspection-data
            :has-data    = "true"
            :show-header = "false"
            :show-body   = "false"
            :show-border = "true"
            title        = "LG Smart"
        >
            <template v-slot:content>
                <div class="v-flex mt-0 pa-3 pb-1">
                    <div style="width: 66.6%" class="pr-4">
                        <div class="v-flex">
                            <p-lg-smart-sensor
                                class="w-50 mr-2"
                                :label      = "escalator ? 'Gateway der Fahrtreppe' : 'Gateway auf dem Fahrkorbdach'"
                                :inspection = "inspection"
                                :sensor     = "lgs.gateway"
                            />

                            <p-lg-smart-sensor
                                class="w-50 ml-2"
                                :label      = "escalator ? 'Sensor Fahrtreppe' : 'Sensor Fahrkorbtür 1'"
                                :inspection = "inspection"
                                :sensor     = "lgs.door_1"
                            />
                        </div>

                        <div class="v-flex mt-4" v-if="escalator">
                            <f-read-only-field
                                class   = "w-50 mr-2"
                                label   = "Fahrtrichtung"
                                :value  = "startDirection"
                                :filled = "true"
                            />
                        </div>

                        <div class="v-flex mt-4" v-else>
                            <p-lg-smart-sensor
                                class="w-50 mr-2"
                                label       = "Sensor Fahrkorbtür 2"
                                :inspection = "inspection"
                                :sensor     = "lgs.door_2"
                            />

                            <p-lg-smart-sensor
                                class="w-50 ml-2"
                                label       = "Sensor Hauptzugangsebene"
                                :inspection = "inspection"
                                :sensor     = "lgs.reference"
                            />
                        </div>
                    </div>
                    <div style="width: 33.3%; height: 100%">
                        <div class="sensor-title primary--text">
                            Montage
                        </div>

                        <div class="lm-border pa-3 pt-0" style="height: 544px">
                            <v-switch
                                v-if="!escalator"
                                class="mt-3"
                                label="Durchladung"
                                v-model="assembly.throughLoading"
                                dense
                                hide-details
                                readonly
                            />

                            <v-switch
                                v-if="!escalator"
                                label="Übereckausladung"
                                v-model="assembly.uebereckausladung"
                                dense
                                hide-details
                                readonly
                            />

                            <v-switch
                                :class="{ 'mt-3': escalator }"
                                label="3-fach Steckdose notwendig"
                                v-model="assembly.addSocket"
                                dense
                                hide-details
                                readonly
                            />

                            <f-read-only-field
                                class="mt-10"
                                label = "LG Smart Montage"
                                :value = "assemblyHint"
                                :filled = "true"
                            />

                            <div style="font-size: 14px; margin-top: 54px">Bemerkungen</div>
                            <div class="notice lm-border pa-2" >
                                {{ assembly.comment }}
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </c-inspection-data>
    </div>
</template>

<script>

import PAreaMixin      from "@/modules/dis/components/inspection/common/mixins/PAreaMixin";
import CInspectionData from "@/modules/dis/components/inspection/common/components/CInspectionData.vue";
import PLgSmartSensor  from "@/modules/dis/components/inspection/lgsmart/components/private/PLgSmartSensor.vue";
import FReadOnlyField  from "@/modules/core/components/utils/FReadOnlyField.vue";
import ConditionLayout from "@/modules/dis/service/inspection/ConditionLayout";
import Escalator       from "@/modules/msd/unit/service/Escalator";

export default {
    name: "PDispositionLiftguardian",

    components: {
        FReadOnlyField,
        PLgSmartSensor,
        CInspectionData,
    },

    mixins: [
        PAreaMixin
    ],

    computed: {
        /**
         * An escalator has a gateway and one sensor (slot door_1) and a start direction (HCIT-912/916); the elevator
         * fields door 2, main access level, through loading and corner loading do not exist (HCIT-1169).
         */
        escalator () {
            return ConditionLayout.isEscalator(this.inspection);
        },

        startDirection () {
            return (this.lgs && Escalator.directionText(this.lgs.startDirection)) || "---";
        },

        lgs () {
            return this.inspection && this.inspection.lgSmart;
        },

        assembly () {
            return this.lgs.assembly;
        },

        assemblyHint () {
            if (!this.assembly || !this.assembly.assemblyHint)  {
                return "---";
            }

            const asseblyHints = this.$store.getters.disposition.assemblyHints;
            const item = asseblyHints.find (i => i.id === this.assembly.assemblyHint.id);
            if (item) {
                return item.name;
            }

            return "---"
        },
    },

    mounted () {
        this.initialize();
    },

    watch: {
        inspection () {
            this.initialize();
        },
    },

    methods: {
        initialize () {
            if (!this.inspection) {
                return;
            }

            this.data = this.inspection.lgSmart;
        },
    }
}
</script>

<style scoped>
.sensor-title {
    font-size: 16px!important;
    font-weight: 500!important;
    text-align: center;
    margin-bottom: 4px;
}

.notice {
    width: 100%;
    height: 150px;
    font-size: 15px;
}

</style>